import { OrderInventoryManagementMethodEnum } from '@eih-netbroker/api-order';

export const InventoryManagmentMethod = OrderInventoryManagementMethodEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InventoryManagmentMethod = (typeof InventoryManagmentMethod)[keyof typeof InventoryManagmentMethod];
